import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { clearTransaction } from '../../../user/actions/transactions/Clear'
import { sendRawTransaction } from '../../../user/actions/transactions/PayTax'
import { getCity } from '../../../user/actions/city/GetCity'
import {
  Container,
  Segment,
  Header,
  Form,
  Button,
  Message,
  Modal
} from 'semantic-ui-react'
import lightwallet from 'eth-lightwallet'


class NoBalanceCity extends Component {

    constructor(props) {
        super(props)

        this.state = {
            inputFee: '',
            errorMessage: false,
            errorMessageText: '',
            showModal: false,
            checkPassword: '',
            checkConfirmPassword: ''
        }

    }

    componentWillReceiveProps(nextProps){

        let { showHashModal  } = nextProps
  
        if(showHashModal){
 
            this.setState({ showModal: false, checkPassword:'', checkConfirmPassword:''})
        }
    }

    transactionIsDone(){

        let { dispatch, authData } = this.props

        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()

        dispatch(clearTransaction())
        
        dispatch(getCity(address[0]))
    }

    checkPasswordOnInputChange(event) {
        this.setState({ checkPassword: event.target.value})
    }
	
    checkPasswordConfirmOnInputChange(event) {
        this.setState({ checkConfirmPassword: event.target.value})
    }

    feeOnInputChange(event) {
        this.setState({ inputFee: event.target.value })
    }

    between(x, min, max) {
        return x >= min && x <= max;
    }
	
    inputFeeSubmit(event) {
        event.preventDefault()
        
        let { dispatch } = this.props

        let fee = this.state.inputFee

        if (!this.between(fee, 0.01, 100)){
            return this.setState({ errorMessage: true, errorMessageText: 'Your fee should be between 0.01 and 100 ETH.' }) 
        }

        dispatch(clearTransaction())
		
        this.setState({ errorMessage: false, showModal: true})
    }

    checkPasswordSubmitFee(event) {
        event.preventDefault()
        
        let { checkPassword, checkConfirmPassword, inputFee } = this.state

        let { dispatch, authData } = this.props

        let keystore = authData.keystore
       
        dispatch(sendRawTransaction(keystore, inputFee, checkPassword, checkConfirmPassword))  
    }


    render() {

        let { errorMessage, errorMessageText, showModal, inputFee, checkPassword, checkConfirmPassword } = this.state

        let { checkLoading, checkErrorMessage, checkErrorMessageText, showHashModal, transactionHash, 
            citizenName} = this.props

        return(
            <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                <Header as='h1' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}>Welcome, {citizenName}
                </Header>
                <Container textAlign='left' text>
                    <p>The last step. To be the law abiding citizen you should pay some tax. After that you can be able to access the City.
                    </p>
                    <Message error hidden={!errorMessage} content={errorMessageText}/>
                    <Form size='large' onSubmit={this.inputFeeSubmit.bind(this)}>
                        <Form.Field>
                            <label>Choose ETH amount to pay</label>
                            <input placeholder='Enter your fee' type="number" step="0.01" min="0.01" max="100" value={inputFee} onChange={this.feeOnInputChange.bind(this)} />
                        </Form.Field>
                        <Button.Group size='large'>
                            <Button positive type='submit'>Submit</Button>
                        </Button.Group>
                    </Form>
                </Container>
                <Modal size='mini' open={showModal} closeOnEscape={!checkLoading} closeOnRootNodeClick={!checkLoading} onClose={() => this.setState({showModal:false, checkPassword:'', checkConfirmPassword:''})} closeIcon={!checkLoading}>
                    <Modal.Header>
                        Confirm your password
                    </Modal.Header>
                    <Modal.Content>
                        <Message error hidden={!checkErrorMessage} content={checkErrorMessageText}/>
                        <Form size='small' onSubmit={this.checkPasswordSubmitFee.bind(this)} loading={checkLoading}>
                            <Form.Field>
                                <label>Password</label>
                                <input type='password' minLength='6' autoComplete='new-password' placeholder='Password' value={checkPassword} onChange={this.checkPasswordOnInputChange.bind(this)} />
                            </Form.Field>
                            <Form.Field>
                                <label>Confirm Password</label>
                                <input type='password' minLength='6' autoComplete='current-password' placeholder='Confirm Password' value={checkConfirmPassword} onChange={this.checkPasswordConfirmOnInputChange.bind(this)} />
                            </Form.Field>
                            <Button.Group size='small'>
                                <Button positive type='submit'>Submit</Button>
                            </Button.Group>
                            <p style={{fontSize: '0.7em'}}>* The transaction can take about a minute</p>
                        </Form>
                    </Modal.Content>
                </Modal>
                <Modal basic size='small' open={showHashModal} onClose={() => this.transactionIsDone()} closeIcon>
                    <Header content='Transaction Hash' />
                    <Modal.Content>
                        <p>Transaction successfully processed. <a href={'https://rinkeby.etherscan.io/tx/'+transactionHash} target="_blank">Here</a> you can find all information about it.</p>
                    </Modal.Content>
                </Modal>
            </Segment>
        )		
    }
}

const mapStateToProps = (state) => {
    return {
        citizenName: state.city.data.citizenName,
        checkLoading: state.transaction.data.checkLoading,
        checkErrorMessage: state.transaction.data.checkErrorMessage,
        checkErrorMessageText: state.transaction.data.checkErrorMessageText,
        showHashModal: state.transaction.data.showHashModal, 
        transactionHash: state.transaction.data.transactionHash
    }
}

export default connect(mapStateToProps)(NoBalanceCity)

NoBalanceCity.propTypes = {
    citizenName: PropTypes.string,
    dispatch: PropTypes.func,
    authData: PropTypes.object,
    checkLoading: PropTypes.bool,
    checkErrorMessage: PropTypes.bool,
    checkErrorMessageText: PropTypes.string,
    showHashModal: PropTypes.bool, 
    transactionHash: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/layouts/city/components/NoBalanceCity.js